/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import { User } from "@/types/user";
import { StateCreator } from "zustand";

export type AuthSlice = {
  isAuthenticated: boolean;
  user: User | null;
  login: (userData?: User) => void;
  logout: () => void;
};

/* -------------------------------------------------------------------------- */
/*                                   Slice                                    */
/* -------------------------------------------------------------------------- */
export const createAuthSlice: StateCreator<AuthSlice> = (set): AuthSlice => ({
  isAuthenticated: false,
  user: null,

  login: (userData?: User) => {
    set({ isAuthenticated: true, user: userData });
  },

  logout: () => {
    set({ isAuthenticated: false, user: null });
  },
});
